import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CustomerSatisfactionSurveyService} from "./customer-satisfaction-survey.service";
import {DtoCustomerSatisfactionSurvey} from "./models/DtoCustomerSatisfactionSurvey";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {PageHeaderBarConfig, PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {DtoEmployeeName} from "../../shared/models/DtoEmployeeName";
import {ScreenService} from "../../../fw/services/screen.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {BreadcrumService, BreadcrumStep} from "../../../fw/services/breadcrum.service";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";

@Component({
    selector: 'ngx-customer-satisfaction-survey',
    template: require('./customer-satisfaction-survey.component.html'),
    styles: [require('./customer-satisfaction-survey.component.css')]
})

export class CustomerSatisfactionSurveyComponent implements OnInit, OnDestroy {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterForm: FormGroup = this.fb.group({
        userId: 0,
        periodId: 2,
        from: null,
        untill: null
    });
    phbConfig: PageHeaderBarConfig = {
        title: 'INSTELLINGEN',
        buttonDefinition: [
            {
                description: 'RESULTATEN',
                isSmall: false,
                clickEventType: 'filter'
            },
        ]
    };
    pshbConfig: PageSubheaderBarConfig = {
        title: 'RESULTATEN',
        buttonDefinition: []
    };
    columnDefinition: Array<ColumnDefinition> = [
        {
            label: 'Vraag',
            type: 'string',
            width: '*',
            key: 'question'
        },
        {
            label: '1',
            type: 'string',
            width: '120',
            key: 'star05Desc'
        },
        {
            label: '2',
            type: 'string',
            width: '120',
            key: 'star1Desc'
        },
        {
            label: '3',
            type: 'string',
            width: '120',
            key: 'star15Desc'
        },
        {
            label: '4',
            type: 'string',
            width: '120',
            key: 'star2Desc'
        },
        {
            label: '5',
            type: 'string',
            width: '120',
            key: 'star25Desc'
        },
        {
            label: '6',
            type: 'string',
            width: '120',
            key: 'star3Desc'
        },
        {
            label: '7',
            type: 'string',
            width: '120',
            key: 'star35Desc'
        },
        {
            label: '8',
            type: 'string',
            width: '120',
            key: 'star4Desc'
        },
        {
            label: '9',
            type: 'string',
            width: '120',
            key: 'star45Desc'
        },
        {
            label: '10',
            type: 'string',
            width: '120',
            key: 'star5Desc'
        },
        {
            label: 'Gemiddeld',
            type: 'number',
            width: '120',
            key: 'avgStar'
        },
        {
            label: 'Totaal',
            type: 'number',
            width: '120',
            key: 'total'
        }
    ];

    branchData: DtoBranchUser[];
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Vandaag", value: 0},
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    data: DtoCustomerSatisfactionSurvey;

    constructor(public breadcrumService: BreadcrumService,
                public ss: SharedService,
                public fb: FormBuilder,
                public ds: CustomerSatisfactionSurveyService,
                public scrs: ScreenService,
                public sds: SharedDataService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'marketing', isLastStep: false },
            { text: 'klanttevredenheidsonderzoek', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.sds.getBranchesWithAll().subscribe(res => this.branchData = res);

        this.setFilterPeriod(2);

        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            if (this.filterForm.get('from').disabled) this.loadData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            if (this.filterForm.get('periodId').value == 5) this.loadData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            if (this.filterForm.get('periodId').value == 5) this.loadData();
        });

        this.loadData();
    }

    ngOnDestroy() {
    }

    phbBtnClicked(event: any) {
        if (event === 'filter')
            this.loadData();
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 0) {
            this.filterForm.patchValue({['from']: this.ss.getCurrentDate()});
            this.filterForm.patchValue({['untill']: this.ss.getCurrentDate()});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 1) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate())});
            this.filterForm.patchValue({['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6)});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 2) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate())});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate())});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 3) {
            this.filterForm.patchValue({['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate())});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate())});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 4) {
            this.filterForm.patchValue({['from']: this.ss.addYearsToDate(this.ss.getFirstDayOfYear(this.ss.getCurrentDate()), -1)});
            this.filterForm.patchValue({['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate())});
            this.filterForm.get('from').disable();
            this.filterForm.get('untill').disable();
        } else if (periodKind == 5) {
            this.filterForm.get('from').enable();
            this.filterForm.get('untill').enable();
        }
    }

    loadData() {
        this.ds.getCustomerSatisfactionSurveys({
            userId: this.filterForm.get('userId').value,
            from: this.filterForm.get('from').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoCustomerSatisfactionSurvey) => {
            this.data = res;
            this.grid.showData(this.data.lines);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/customer-satisfaction-survey/customer-satisfaction-survey.component.ts